<template>
  <div class="HelpContent">
    <!-- 如何下载安装电子书？ -->
    <div class="section help1" id="help1">
      <h3>
        如何下载安装电子书？
        <span class="toTop" @click="toTop()">[To Top]</span>
      </h3>
      <h4>一、Android用户</h4>
      <div class="paragraph1">
        1. 打开手机的浏览器，在地址栏输入：ebook.pep.com.cn/ry，并打开网页；
        <br />
        2. 在打开的页面内，通过点击“立即下载”按钮来下载电子书安装程序；
        <br />
        3. 下载完成后，打开安装包，点击“安装”。
      </div>
      <h4>二、iOS用户</h4>
      <div class="paragraph1">
        1. 打开App Store，选择“搜索”选项；<br />
        2. 输入“标准日本语”，并进行搜索；<br />
        3. 找到并打开“《标准日本语》电子书”，点击“免费”进行安装。
      </div>
    </div>
    <!-- 如何激活电子书？ -->
    <div class="section help2" id="help2">
      <h3>
        如何激活电子书？<span class="toTop" @click="toTop()">[To Top]</span>
      </h3>
      <h4>新用户（在注册时激活电子书）：</h4>
      <div class="paragraph1">
        1. 刮开图书封底的激活码涂层获取激活码；<br />
        2. 下载、安装电子书；<br />
        3.
        启动电子书，在注册过程中根据提示输入激活码，选择电子书（初级、中级或高级）并
        <br />&nbsp;&nbsp;&nbsp;激活。
      </div>
      <h4>已注册用户：</h4>
      <div class="paragraph1">
        1. 刮开图书封底的激活码涂层获取激活码；<br />
        2. 确认已经下载安装电子书、且已经注册并登录；<br />
        3. 在电子书主界面点击右上角“设置”按钮->“资源管理”项；<br />
        4. 选择电子书（初级、中级或高级），根据提示输入激活码并激活。
      </div>
    </div>
    <!-- 如果选错书了怎么办？ -->
    <div class="section help3" id="help3">
      <h3>
        如果选错书了怎么办？<span class="toTop" @click="toTop()">[To Top]</span>
      </h3>
      <h4 style="text-indent: 2em">
        在首次使用激活码成功激活电子书7天内，如发现选错了书，可以重新激活并再选一次电子书（仅此一次机会），操作如下：
      </h4>
      <div class="paragraph1">
        1. 在电子书主界面点击右上角的“设置”按钮->“资源管理”项；<br />
        2. 在被错误激活的图书下方，点击“重新激活”按钮；<br />
        3. 按照提示选择正确的图书激活即可。
      </div>
    </div>
    <!-- 如何获得激活码？ -->
    <div class="section help4" id="help4">
      <h3>
        如何获得激活码？<span class="toTop" @click="toTop()">[To Top]</span>
      </h3>
      <h4 style="text-indent: 2em">
        购买正版图书即可随书得到一个激活码（如图），其已附在第二版《新版
        中日交流标准日本语》纸质图书封底（刮开涂层即是）。
      </h4>
      <div class="img-wrap">
        <img
          src="@/assets/images/14ry_tp04.jpg"
          alt=""
          width="352"
          height="408"
        />
      </div>
    </div>
    <!-- 更多问题请关注微信。 -->
    <div class="section help5" id="help5">
      <h3>
        更多问题请关注微信。<span class="toTop" @click="toTop()">[To Top]</span>
      </h3>
      <h4 style="text-indent: 2em">
        如果您在使用“标日电子书”的过程中，遇到其他其问题，欢迎通过我们的官方微信“XueBiaoRi”中的“微客服”提交，我们会有专人为您解决。关注微信后，您还可以获得“标日”相关的最新信息、学习资料以及参与我们的有奖活动等。
      </h4>
      <div class="img-wrap">
        <img src="@/assets/images/14br_q5.jpg" alt="" width="400" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isScrolling: false,
    };
  },

  watch: {
    "$route.params": {
      handler(newParams) {
        console.log("路由参数变化:", newParams);
        if (newParams && newParams.anchor) {
          this.$nextTick(() => {
            this.scrollToAnchor(newParams.anchor);
          });
        }
      },
      immediate: true,
      deep: true,
    },

    $route: {
      handler(to) {
        console.log("路由变化:", to);
        if (to && to.params && to.params.anchor) {
          this.$nextTick(() => {
            this.scrollToAnchor(to.params.anchor);
          });
        }
      },
      immediate: true,
    },
  },

  mounted() {
    console.log("HelpContent组件加载完成:", this.$route.params);

    // 初始化时滚动到指定锚点
    if (this.$route.params && this.$route.params.anchor) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToAnchor(this.$route.params.anchor);
        }, 300); // 增加延迟确保DOM渲染完成
      });
    }

    // 监听父组件的滚动事件
    if (this.$root) {
      this._helpScrollHandler = (anchor) => {
        console.log("HelpContent收到父组件滚动事件:", anchor);
        this.scrollToAnchor(anchor);
      };
      this.$root.$on && this.$root.$on("help-scroll", this._helpScrollHandler);
    }
  },

  beforeDestroy() {
    if (this.$root && this._helpScrollHandler) {
      this.$root.$off &&
        this.$root.$off("help-scroll", this._helpScrollHandler);
    }
  },

  methods: {
    toTop() {
      console.log("To Top 点击 - HelpContent");

      if (this.isScrolling) return;
      this.isScrolling = true;

      // 直接滚动到页面绝对顶部
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });

      // 多重保障确保滚动到顶部
      setTimeout(() => {
        // 强制设置滚动位置为0
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        // 处理可能的父级滚动容器
        const containers = [
          document.querySelector(".help-content"),
          document.querySelector(".main"),
          document.querySelector(".content-layout"),
          document.querySelector(".basic-layout"),
        ];

        containers.forEach((container) => {
          if (container && container.scrollTop > 0) {
            container.scrollTop = 0;
          }
        });

        console.log(
          "To Top 执行完成，当前滚动位置:",
          window.pageYOffset || document.documentElement.scrollTop
        );
      }, 300);

      // 额外的安全检查，确保真正到达顶部
      setTimeout(() => {
        const currentScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        if (currentScroll > 0) {
          console.log(
            "检测到未完全置顶，再次执行滚动，当前位置:",
            currentScroll
          );
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          window.scrollTo(0, 0);
        }
        this.isScrolling = false;
      }, 1000);
    },

    scrollToAnchor(anchor) {
      if (!anchor || this.isScrolling) {
        console.log("HelpContent跳过滚动:", {
          anchor,
          isScrolling: this.isScrolling,
        });
        return;
      }

      console.log("HelpContent开始处理锚点:", anchor);
      this.isScrolling = true;

      // 查找目标元素
      const selectors = [
        `#${anchor}`,
        `.${anchor}`,
        `.section.${anchor}`,
        `[data-anchor="${anchor}"]`,
      ];

      let element = null;
      for (const selector of selectors) {
        element = document.querySelector(selector);
        if (element) {
          console.log("HelpContent找到元素:", selector);
          break;
        }
      }

      if (!element) {
        console.warn("HelpContent未找到锚点元素:", anchor);
        this.isScrolling = false;
        return;
      }

      // 执行简单的滚动处理
      this.executeSimpleScroll(element, anchor);
    },

    // 简化的滚动处理
    executeSimpleScroll(element, anchor) {
      console.log("HelpContent执行简单滚动", anchor ? `到锚点: ${anchor}` : "");

      const calculateOffset = () => {
        const width = window.innerWidth;
        let offset = 88; // 默认偏移

        if (width <= 480) offset = 80;
        else if (width <= 768) offset = 90;
        else if (width <= 1024) offset = 100;

        return offset;
      };

      const rect = element.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const offset = calculateOffset();
      const targetPosition = Math.max(0, rect.top + scrollTop - offset);

      console.log("HelpContent滚动信息:", {
        anchor: anchor || "unknown",
        elementTop: rect.top,
        scrollTop,
        offset,
        targetPosition,
      });

      // 简单的滚动方法
      try {
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
        console.log("HelpContent滚动执行完成");
      } catch (e) {
        console.log("HelpContent滚动失败:", e);
        // 备选方案
        try {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } catch (e2) {
          console.log("HelpContent备选滚动也失败:", e2);
        }
      }

      // 重置状态
      setTimeout(() => {
        this.isScrolling = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.HelpContent {
  // 为所有section元素添加scroll-margin-top，处理固定头部偏移
  .section {
    scroll-margin-top: 120px; // PC端默认偏移

    // 移动端响应式偏移调整
    @media (max-width: 1024px) {
      scroll-margin-top: 100px;
    }

    @media (max-width: 768px) {
      scroll-margin-top: 90px;
    }

    @media (max-width: 480px) {
      scroll-margin-top: 80px;
    }
  }

  // 移动端响应式样式
  @media (max-width: 1024px) {
    .section {
      padding: 20px !important;
      margin-bottom: 20px !important;
      border-radius: 8px !important;
      background: white !important;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;

      h3 {
        font-size: 28px !important;
        text-align: center !important;
        margin-bottom: 25px !important;
        color: #090 !important;
        line-height: 1.3 !important;

        .toTop {
          font-size: 14px !important;
          color: #000 !important;
          cursor: pointer !important;
          margin-left: 15px !important;
          padding: 5px 10px !important;
          background: rgba(0, 0, 0, 0.05) !important;
          border-radius: 4px !important;
          transition: all 0.3s ease !important;

          &:hover {
            background: rgba(0, 0, 0, 0.1) !important;
            text-decoration: none !important;
          }
        }
      }

      h4 {
        font-size: 20px !important;
        color: #000 !important;
        margin: 25px 0 15px 0 !important;
        line-height: 1.4 !important;
        font-weight: 600 !important;
      }

      .paragraph1 {
        font-size: 16px !important;
        color: #666 !important;
        line-height: 1.8 !important;
        margin-bottom: 15px !important;
        text-align: justify !important;
      }

      .img-wrap {
        text-align: center !important;
        margin: 25px 0 !important;

        img {
          max-width: 100% !important;
          height: auto !important;
          border-radius: 8px !important;
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1) !important;
        }
      }
    }
  }

  // 小屏幕设备优化
  @media (max-width: 768px) {
    .section {
      padding: 15px !important;
      margin-bottom: 15px !important;

      h3 {
        font-size: 24px !important;
        margin-bottom: 20px !important;

        .toTop {
          font-size: 13px !important;
          margin-left: 10px !important;
          padding: 4px 8px !important;
        }
      }

      h4 {
        font-size: 18px !important;
        margin: 20px 0 12px 0 !important;
      }

      .paragraph1 {
        font-size: 15px !important;
        line-height: 1.7 !important;
        margin-bottom: 12px !important;
      }

      .img-wrap {
        margin: 20px 0 !important;
      }
    }
  }

  // 超小屏幕优化
  @media (max-width: 480px) {
    .section {
      padding: 12px !important;
      margin-bottom: 12px !important;

      h3 {
        font-size: 22px !important;
        margin-bottom: 18px !important;

        .toTop {
          font-size: 12px !important;
          margin-left: 8px !important;
          padding: 3px 6px !important;
        }
      }

      h4 {
        font-size: 16px !important;
        margin: 18px 0 10px 0 !important;
      }

      .paragraph1 {
        font-size: 14px !important;
        line-height: 1.6 !important;
        margin-bottom: 10px !important;
      }

      .img-wrap {
        margin: 18px 0 !important;
      }
    }
  }

  // 触摸设备优化
  @media (hover: none) and (pointer: coarse) {
    .section {
      h3 {
        .toTop {
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1) !important;
          min-height: 44px !important;
          min-width: 44px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;

          &:active {
            transform: scale(0.95) !important;
            background: rgba(0, 0, 0, 0.15) !important;
          }
        }
      }
    }
  }
}
</style>
